import Heading from '../typography/Heading';

const CoreValues = () => {
  const coreValues = [
    {
      id: 1,
      title: 'Transparency',
      description: 'Every transaction and update is clear and accessible.',
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#7A57F4" />
          <path
            d="M32 43.3333C29.224 43.3333 26.8633 42.3794 24.918 40.4716C22.9727 38.564 22 36.229 22 33.4666C22 32.1248 22.2629 30.8646 22.7887 29.6859C23.3142 28.5073 24.0274 27.4547 24.9283 26.5283L32 19.5896L39.0717 26.5283C39.9726 27.4547 40.6858 28.5073 41.2113 29.6859C41.7371 30.8646 42 32.1248 42 33.4666C42 36.229 41.0273 38.564 39.082 40.4716C37.1367 42.3794 34.776 43.3333 32 43.3333ZM24.0793 34.6666H39.8793C40.146 33.0666 39.9939 31.6957 39.423 30.5539C38.8521 29.4119 38.2667 28.552 37.6667 27.9743L32 22.3743L26.3333 27.9743C25.7333 28.552 25.1466 29.4119 24.573 30.5539C23.9994 31.6957 23.8349 33.0666 24.0793 34.6666Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      id: 2,
      title: 'Efficiency',
      description: 'Simplifying property and resident management for everyone.',
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#24C661" />
          <path
            d="M30.0675 40.2665L36.9675 31.9998H31.6342L32.6008 24.4331L26.4342 33.3331H31.0675L30.0675 40.2665ZM27.4368 44.5895L28.7702 35.3331H22.6035L33.5905 19.4741H35.2315L33.9112 29.9998H41.2442L29.0778 44.5895H27.4368Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      id: 3,
      title: 'Trust',
      description:
        'Building stronger connections between owners, managers, and residents.',
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#357AE1" />
          <path
            d="M30.3207 35.6668H33.6793L32.9257 31.4564C33.3443 31.2769 33.6814 30.9953 33.937 30.6118C34.1926 30.228 34.3203 29.8019 34.3203 29.3334C34.3203 28.6941 34.0934 28.1475 33.6397 27.6938C33.1859 27.24 32.6393 27.0131 32 27.0131C31.3607 27.0131 30.8141 27.24 30.3603 27.6938C29.9066 28.1475 29.6797 28.6941 29.6797 29.3334C29.6797 29.8019 29.8074 30.228 30.063 30.6118C30.3186 30.9953 30.6557 31.2769 31.0743 31.4564L30.3207 35.6668ZM32 44.6411C29.1162 43.8547 26.7287 42.1572 24.8373 39.5488C22.9458 36.9403 22 34.0241 22 30.8001V23.1284L32 19.3848L42 23.1284V30.8001C42 34.0241 41.0542 36.9403 39.1627 39.5488C37.2713 42.1572 34.8838 43.8547 32 44.6411ZM32 42.5334C34.3111 41.8001 36.2222 40.3334 37.7333 38.1334C39.2444 35.9334 40 33.489 40 30.8001V24.5001L32 21.5128L24 24.5001V30.8001C24 33.489 24.7556 35.9334 26.2667 38.1334C27.7778 40.3334 29.6889 41.8001 32 42.5334Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      id: 4,
      title: 'Innovation',
      description: 'Continuously improving with smart technology.',
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#F5C902" />
          <path
            d="M32 43.9229C31.4649 43.9229 30.9918 43.7819 30.5807 43.4999C30.1696 43.2177 29.882 42.8476 29.718 42.3896H29.3333C28.788 42.3896 28.3183 42.1926 27.9243 41.7986C27.5303 41.4046 27.3333 40.9349 27.3333 40.3896V36.0153C25.988 35.1999 24.9294 34.1068 24.1577 32.7359C23.3859 31.3648 23 29.8973 23 28.3333C23 25.8239 23.8727 23.6966 25.618 21.9513C27.3633 20.2059 29.4907 19.3333 32 19.3333C34.5093 19.3333 36.6367 20.2059 38.382 21.9513C40.1273 23.6966 41 25.8239 41 28.3333C41 29.9246 40.6141 31.3989 39.8423 32.7563C39.0706 34.1136 38.012 35.1999 36.6667 36.0153V40.3896C36.6667 40.9349 36.4697 41.4046 36.0757 41.7986C35.6817 42.1926 35.212 42.3896 34.6667 42.3896H34.282C34.118 42.8476 33.8304 43.2177 33.4193 43.4999C33.0082 43.7819 32.5351 43.9229 32 43.9229ZM29.3333 40.3896H34.6667V39.1383H29.3333V40.3896ZM29.3333 37.9589H34.6667V36.6666H29.3333V37.9589ZM29.0667 34.6666H31.205V30.7846L28.3487 27.9283L29.4667 26.8103L32 29.3436L34.5333 26.8103L35.6513 27.9283L32.795 30.7846V34.6666H34.9333C36.1333 34.0888 37.1111 33.2388 37.8667 32.1166C38.6222 30.9944 39 29.7333 39 28.3333C39 26.3777 38.3222 24.7221 36.9667 23.3666C35.6111 22.011 33.9556 21.3333 32 21.3333C30.0444 21.3333 28.3889 22.011 27.0333 23.3666C25.6778 24.7221 25 26.3777 25 28.3333C25 29.7333 25.3778 30.9944 26.1333 32.1166C26.8889 33.2388 27.8667 34.0888 29.0667 34.6666Z"
            fill="white"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="w-full">
      <div className="container mx-auto px-5 lg:px-0">
        <div className="mb-4 md:mb-12 text-center">
          <Heading>Core Values</Heading>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
          {coreValues.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-2xl p-4 md:p-8 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="mb-4 md:mb-12">{item.icon}</div>
              <h2 className="text-base md:text-2xl font-bold text-primary mb-4">
                {item.title}
              </h2>
              <p className="text-secondary leading-relaxed text-base md:text-lg">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoreValues;
